import { AppBar, Toolbar, useTheme } from "@mui/material";
import {
	DeleteButton,
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	ResetButton,
	SubmitButton,
} from "@websential/cosmic-v20";

import { FC } from "react";

export interface IRoleAssignmentSetupToolbar {
	onResetClicked: () => void;
	// onDeleteClicked: () => void;
	isSubmitting: boolean;
	id?: any;
}

export const RoleAssignmentSetupToolbar: FC<IRoleAssignmentSetupToolbar> = ({
	onResetClicked,
	// onDeleteClicked,
	isSubmitting = false,
	id,
}) => {
	const theme = useTheme();
	return (
		<AppBar
			position="sticky"
			color="default"
			elevation={1}
			sx={{
				backgroundColor: "#fff",
				// marginTop: theme.spacing(3),
				boxShadow: "none",
				alignItems: "center",
				bottom: 0,
				zIndex: 0
			}}
		>
			<Toolbar>
				<>
					<EnhancedButtonPrimeReact
						label="Submit"
						loading={isSubmitting}
						type="submit"
						// icon="pi pi-check"
						raised
						severity={EnhancedButtonPrimeReactSeverity.Success}
					/>
					<EnhancedButtonPrimeReact
						// icon="pi pi-plus"
						label="Reset"
						raised
						onClickHandler={onResetClicked}
						style={{ marginLeft: "1rem" }}
						severity={EnhancedButtonPrimeReactSeverity.Secondary}
					/>
					{/* <EnhancedButtonPrimeReact
						// icon="pi pi-trash"
						label="Delete"
						raised
						onClickHandler={onDeleteClicked}
						style={{ marginLeft: "1rem" }}
						severity={EnhancedButtonPrimeReactSeverity.Danger}
						disabled={!id ? true : false}
					/> */}
				</>
			</Toolbar></AppBar>
	);
};
